import _Symbol$for from "@babel/runtime-corejs3/core-js/symbol/for";
import _Map from "@babel/runtime-corejs3/core-js/map";
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
/**
 * @module
 *
 * These are globals that are used by the ModalRegister.
 * these are globals to avoid needing to make this package
 * a peer-dependency (a singleton in a bundle).
 * Thus allowing multiple versions of this package to be present in
 * a bundle without causing issues.
 *
 * The need for globals will go away once we implement the `app-kernel`
 * in the Union Evolution project.
 */
import React from "react";
import { createActiveBranchStack, createRegisterNode } from "./ModalRegister/RegisterTree.js";
const packageGlobals = _Symbol$for('@xo-union/ui-accessibility-globals');
const initGlobals = () => {
  const rootRegisterNode = createRegisterNode();
  const activeBranchStack = createActiveBranchStack(rootRegisterNode);
  const rootRegister = {
    level: 0,
    isActive: false,
    isVisible: true,
    registerNode: rootRegisterNode
  };
  const activeBranchStackInitEffect = () => {
    activeBranchStack.mount();
    return () => activeBranchStack.unmount();
  };
  const ModalRegisterTreeContext = /*#__PURE__*/React.createContext(rootRegister);
  const ModalPortalRefContext = /*#__PURE__*/React.createContext(null);
  const globalEffectsCounterMap = new _Map();
  const globalEffectsTeardownMap = new _Map();
  return {
    rootRegisterNode,
    activeBranchStack,
    rootRegister,
    activeBranchStackInitEffect,
    globalEffectsCounterMap,
    globalEffectsTeardownMap,
    ModalRegisterTreeContext,
    ModalPortalRefContext
  };
};
_globalThis[packageGlobals] = _globalThis[packageGlobals] || initGlobals();
export const {
  rootRegister,
  rootRegisterNode,
  activeBranchStack,
  activeBranchStackInitEffect,
  globalEffectsCounterMap,
  globalEffectsTeardownMap,
  ModalRegisterTreeContext,
  ModalPortalRefContext
} = _globalThis[packageGlobals];